export default {"src":"https://cdn.jetlend.ru/_next/static/media/youtube-icon.e198777e.svg","height":15,"width":21,"blurWidth":0,"blurHeight":0};